export type Destructor = () => void

export class Destructors {
  private destructors: Destructor[] = []

  add(destructor: Destructor) {
    this.destructors.push(destructor)
  }

  destroy() {
    for (const destructor of this.destructors) {
      try {
        destructor()
      } catch (e) {
        console.error('destructor failed', e)
      }
    }
    this.destructors = []
  }
}
